import {
  ImageCtaCardSection,
  TrimixHeroContentSection,
  TrimixPriceOverviewSection,
  TrimixGeneralStepCard,
  TrimixWhyItWorksSection,
  TrimixFeaturedMedSection,
} from "@/design-system/Organisms";
import { trimixMidImageCtaCardConfig } from "@/design-system/Organisms/ImageCtaCardSection/imageCtaCard.config";
import { trimixFeaturedMedicineConfig } from "@/design-system/Organisms/TrimixFeaturedMedSection/featuredMed.config";

export const TrimixBgSwoopTemplate = () => {
  return (
    <>
      <div className="w-full h-full overflow-hidden bg-no-repeat bg-contain bg-[url('/images/bg-swoop.svg')] bg-[position:0_-100px]">
        <TrimixHeroContentSection />
        <TrimixPriceOverviewSection />
        <TrimixGeneralStepCard />
        <TrimixWhyItWorksSection />
        <TrimixFeaturedMedSection {...trimixFeaturedMedicineConfig} />
        <ImageCtaCardSection {...trimixMidImageCtaCardConfig} />
      </div>
    </>
  );
};
export default TrimixBgSwoopTemplate;
